var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
// '#components' is imported by direct path: its barrel would close the hooks <-> components cycle (see CLAUDE.md).
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { translate, useModal } from '@lucidlink/uicore';
import { WorkspaceLimitModal } from '#components/modals/WorkspaceLimitModal';
import { useCurrentMemberByWorkspaceId, useFilespaceListByWorkspaceId, useWorkspaceById, } from '#query-hooks';
import { workspaceRoutes } from '#services';
export const useCreateFilespaceFlow = (workspaceId) => {
    _react_refresh_temp_1();
    const navigate = useNavigate();
    const { query: { data: workspace }, } = useWorkspaceById(workspaceId);
    const { query: { data: member }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { query: { data: filespaces }, } = useFilespaceListByWorkspaceId(workspaceId);
    const { closeModal, openModal } = useModal({ closeOnUnmount: false });
    const startCreateFilespace = useCallback(() => {
        if (!workspace?.canCreateFilespace) {
            openModal({
                content: (_jsx(WorkspaceLimitModal, { canAccessBilling: Boolean(member?.privileges?.billing), closeModal: closeModal, text: translate('Your current plan includes up to {{filespacesCount}} filespace. To create additional filespaces, upgrade your plan.', {
                        filespacesCount: filespaces?.length ?? 0,
                    }), workspaceId: workspaceId })),
            });
            return;
        }
        void navigate(workspaceRoutes.workspaceFilespaceCreate(workspaceId));
    }, [
        workspace?.canCreateFilespace,
        member?.privileges?.billing,
        filespaces?.length,
        openModal,
        closeModal,
        navigate,
        workspaceId,
    ]);
    return { startCreateFilespace };
};
_react_refresh_temp_1(useCreateFilespaceFlow, "zyyh480sRgeyGYtiUGmFU3PO9Qw=", false, () => [useNavigate, useWorkspaceById, useCurrentMemberByWorkspaceId, useFilespaceListByWorkspaceId, useModal]);
